import { connect } from "react-redux";

import { post } from "../../../../../actions/general";
import { editTask } from "../../../../../store/plan/actions";
import { changeRhythmSyllableType } from "../../../../../store/user/actions";

import Component from "./lazy";

const mapStateToProps = ({ user }) => ({
    user,
});

const mapDispatchToProps = {
    changeRhythmSyllableType,
    editTask,
    post,
};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
